import React, {FunctionComponent, useEffect, useState, useMemo} from "react"
import {ColumnHeaderCell} from "./Models"
import {IconContext} from "react-icons/lib"
import {HiOutlineSelector, HiChevronUp, HiChevronDown} from "react-icons/hi"
import { getUserTableSpanClass } from "../ColumnGroupTable/TableUtils"

interface ColumnHeaderProps {
	col: ColumnHeaderCell
	sortedAscending: boolean
	sorted: boolean
	sortByColumn: (column: string) => void
	sortedColumn: string
}

const ColumnHeader:FunctionComponent<ColumnHeaderProps> = ({
	col,
	sortedAscending,
	sorted,
	sortByColumn,
	sortedColumn
}) => {
	const unsortedIcon = (
		<IconContext.Provider value={{className: "user-table-small-icon"}}>
			<HiOutlineSelector />
		</IconContext.Provider>
	)

	const sortedAscendingIcon = (
		<IconContext.Provider value={{className: "user-table-small-icon"}}>
			<HiChevronUp />
		</IconContext.Provider>
	)

	const sortedDescendingIcon = (
		<IconContext.Provider value={{className: "user-table-small-icon"}}>
			<HiChevronDown />
		</IconContext.Provider>
	)

	const getSortingIcon = (sorted: boolean, sortedAscending: boolean, columnKey: string) => {
		if (columnKey !== sortedColumn)
			return unsortedIcon

		if (sorted && sortedAscending === true) {
			return sortedAscendingIcon
		}
		if (sorted && sortedAscending === false) {
			return sortedDescendingIcon
		}

		return unsortedIcon
	}

	return (
		<th scope='col' key={col.columnKey} className={`table-column ${getUserTableSpanClass(col.size)}`}>
			{!col.isSortable ? (
				<div className="table-column-head-regular">{col.displayName}</div>
			) : (
				<div
					className='table-column-head-wrapper'
					onClick={() => sortByColumn(col.columnKey)}
				>
					{col.displayName}
					{col.isSortable && getSortingIcon(sorted, sortedAscending, col.columnKey)}
				</div>
			)}
		</th>
	)
}

export default ColumnHeader
